export { default } from "./TermsPage";
